import type { ArtworkDescriptor, BlobDoc, Track } from '../types';

export function formatDuration(totalSeconds: number) {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const mins = Math.floor(seconds / 60)
    .toString()
    .padStart(1, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return `${mins}:${secs}`;
}

export function createObjectUrl(blobDoc?: BlobDoc | null) {
  return blobDoc ? URL.createObjectURL(blobDoc.blob) : undefined;
}

export function revokeObjectUrl(url?: string) {
  if (url) URL.revokeObjectURL(url);
}

function hashToHue(input: string) {
  let value = 0;
  for (let index = 0; index < input.length; index += 1) {
    value = (value * 31 + input.charCodeAt(index)) % 360;
  }
  return value;
}

export function buildArtworkDescriptor(track: Pick<Track, 'title' | 'artist' | 'album' | 'id'>) {
  const hue = hashToHue(`${track.id}-${track.title}-${track.artist}`);
  const gradient = `linear-gradient(135deg, hsl(${hue} 72% 42%), hsl(${(hue + 80) % 360} 82% 52%))`;
  const initials = `${track.title.charAt(0)}${track.artist.charAt(0)}`.trim().toUpperCase();

  return {
    gradient,
    label: initials || track.title.slice(0, 2).toUpperCase()
  } satisfies ArtworkDescriptor;
}

export function clampPosition(time: number, duration: number) {
  return Math.min(Math.max(time, 0), duration || 0);
}
